/**
 * Executes an async function only if no other tab is currently running it.
 * @param {string} key - The unique name for this lock (e.g., 'refresh_lock')
 * @param {Function} fn - The async function to run
 * @param {number} ttl - Time-to-live in ms (default 10s) to prevent permanent stuck locks
 */
export async function withLocalStorageLock(key, fn, ttl = 10000) {
    const now = Date.now();
    const lockValue = localStorage.getItem(key);

    // 1. Check if a valid lock exists
    if (lockValue && (now - parseInt(lockValue)) < ttl) {
        //console.log(`Lock [${key}] is active. Skipping execution.`);
        return null;
    }

    try {
        localStorage.setItem(key, now.toString());
        
        // Run the actual work
        return await fn();
    } finally {
        // Always unlock, even if the function crashes
        localStorage.removeItem(key);
    }
}

export function getLanguage() {
    return localStorage.getItem('language') || 'en';
}